<template>
    <v-col v-bind="DASHBOARD_WIDGET_COLUMNS.SMALL">
        <v-card>
            <v-toolbar color="grey-lighten-4" density="compact" flat>
                <template #title>{{ widget.body?.title }}</template>
            </v-toolbar>

            <v-divider />

            <v-card-text>
                <v-data-table
                    :headers="headers"
                    :items="sortedItems"
                    :loading="loading"
                    density="compact"
                    height="300"
                    item-value="name"
                >
                    <template #item.count="{ item }">
                        {{ formatNumber(orderRow(item).count) }}
                    </template>
                    <template #item.sum="{ item }">
                        {{ formatNumber(orderRow(item).sum) }}
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </v-col>
</template>

<script setup lang="ts">
/*
Organization / ordering applied:
1. Imports
2. Props / Emits
3. Constants
4. Stores & top-level services
5. Reactive state (refs/reactive)
6. Validation rules & setup
7. Computed
8. Handlers / methods
9. Helpers / lifecycle
*/

// 1. Imports
import { computed } from 'vue'

import type { DashboardWidget } from '@/stores/dashboard'
import type { DataTableHeader } from '@/types/dataTable'
import { DASHBOARD_WIDGET_COLUMNS, formatNumber } from '@/views/Dashboard/dashboardUtils'

// 2. Props / Emits
const props = withDefaults(
    defineProps<{
        widget: DashboardWidget
        items?: unknown[]
        loading?: boolean
    }>(),
    { items: () => [], loading: false }
)

// 3. Constants
const headers: DataTableHeader[] = [
    { title: 'Produkt', key: 'name', sortable: false },
    { title: 'Ilość zamówień', key: 'count', sortable: false, align: 'start' },
    { title: 'Nakład', key: 'sum', sortable: false, align: 'start' }
]

function orderRow(item: unknown): { count?: unknown; sum?: unknown } {
    return item as { count?: unknown; sum?: unknown }
}

// 7. Computed
const sortedItems = computed(() =>
    [...(props.items ?? [])].sort((a, b) => {
        const rowA = a as { count?: unknown }
        const rowB = b as { count?: unknown }
        return Number(rowB?.count || 0) - Number(rowA?.count || 0)
    })
)
</script>
